import {PropsWithTheme, ThemeSchema, ThemeVariants} from './../types';

export default (props: PropsWithTheme): ThemeSchema => props.theme;

export const id = (props: PropsWithTheme): ThemeVariants => props.theme.id;
